"use client";

import { Clock, Bell } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useEffect, useRef, useState } from "react";
export default function HorarioDeLaCeremoniaYRecepcion() {
  const ceremonyRef = useRef<HTMLDivElement>(null);
  const receptionRef = useRef<HTMLDivElement>(null);
  const [ceremonyVisible, setCeremonyVisible] = useState(false);
  const [receptionVisible, setReceptionVisible] = useState(false);
  useEffect(() => {
    const ceremonyObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setCeremonyVisible(true);
          ceremonyObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2
    });
    const receptionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setReceptionVisible(true);
          receptionObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.2
    });
    if (ceremonyRef.current) ceremonyObserver.observe(ceremonyRef.current);
    if (receptionRef.current) receptionObserver.observe(receptionRef.current);
    return () => {
      ceremonyObserver.disconnect();
      receptionObserver.disconnect();
    };
  }, []);
  return <section className="dark bg-background text-foreground py-20 px-2 sm:px-4 relative overflow-hidden" id="horario-de-la-ceremonia-y-recepción">
      <div className="container mx-auto max-w-[72rem]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">

          {}
          <div ref={ceremonyRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${ceremonyVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <Card className="border-none overflow-hidden rounded-[var(--radius-md)] shadow-soft p-0">
              <CardContent className="relative p-0 aspect-auto md:aspect-[4/5] overflow-hidden">

                {}
                <img src="https://dondeseacabaelmar.com/wp-content/uploads/2026/02/iglesia-sanjulian-1.jpg" alt="Concatedral de San Julián" className="absolute inset-0 w-full h-full object-cover" />

                {}
                <div className="absolute inset-0 bg-primary-dark/60 backdrop-blur-sm" />

                {}
                <div className="relative z-10 flex flex-col items-center justify-center text-center py-16 md:h-full px-6">
                  <div className="mb-6 p-6 rounded-full bg-primary/40 backdrop-blur-md hover:scale-110 transition-transform">
                    <Clock className="w-16 h-16 text-white drop-shadow-lg" strokeWidth={1.5} />
                  </div>

                  <h2 className="font-display text-[2.125rem] font-semibold mb-4 text-white drop-shadow-lg">
                    Ceremonia
                  </h2>

                  <div className="space-y-3">
                    <p className="text-xl font-semibold text-white drop-shadow-md">
                      12:30 horas
                    </p>
                    <p className="text-lg text-white drop-shadow-md">
                      Sábado, 8 de agosto de 2026
                    </p>
                    <p className="text-base text-white mt-4 drop-shadow-md">
                      Concatedral de San Julián
                    </p>
                  </div>

                  <Link to="https://www.google.com/maps/search/?api=1&query=Concatedral+de+San+Julián+Ferrol" newTab className="btn-primary mt-8">
                    Cómo llegar
                  </Link>
                </div>

              </CardContent>
            </Card>
          </div>

          {}
          <div ref={receptionRef} className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${receptionVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            <Card className="border-none overflow-hidden rounded-[var(--radius-md)] shadow-soft p-0">
              <CardContent className="relative p-0 aspect-auto md:aspect-[4/5] overflow-hidden">

                {}
                <img src="https://dondeseacabaelmar.com/wp-content/uploads/2026/02/1.jpg" alt="Pazo de Vilaboa" className="absolute inset-0 w-full h-full object-cover" />

                {}
                <div className="absolute inset-0 bg-primary-dark/60 backdrop-blur-sm" />

                {}
                <div className="relative z-10 flex flex-col items-center justify-center text-center py-16 md:h-full px-6">
                  <div className="mb-6 p-6 rounded-full bg-secondary/40 backdrop-blur-md hover:scale-110 transition-transform">
                    <Bell className="w-16 h-16 text-white drop-shadow-lg" strokeWidth={1.5} />
                  </div>

                  <h2 className="font-display text-[2.125rem] font-semibold mb-4 text-white drop-shadow-lg">
                    Banquete
                  </h2>

                  <div className="space-y-3">
                    <p className="text-xl font-semibold text-white drop-shadow-md">
                      15:30 horas
                    </p>
                    <p className="text-lg text-white drop-shadow-md">
                      Sábado, 8 de agosto de 2026
                    </p>
                    <p className="text-base text-white mt-4 drop-shadow-md">
                      Pazo de Vilaboa
                    </p>
                  </div>

                  <Link to="https://www.google.com/maps/search/?api=1&query=Pazo+de+Vilaboa+Culleredo" newTab className="btn-primary mt-8">
                    Cómo llegar
                  </Link>
                </div>

              </CardContent>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}